module.exports = __webpack_public_path__ + "img/chip-orange.27d28e62.png";